import React from 'react'

import { Accept, useDropzone } from 'react-dropzone'

import { Chip, makeAppStyles, Typography } from '@percept/mui'

import { InsertDriveFile } from '@percept/mui/icons'

import { humanReadableFilesize } from '@percept/utils'


const useImageUploadStyles = makeAppStyles( theme => ({
  dropzone: {
    minHeight: '10rem',
    minWidth: '20rem',
    padding: theme.spacing(3),
    margin: theme.spacing(4, 0),
    borderRadius: theme.shape.borderRadius,
    border: 'dashed 3px',
    color: theme.palette.action.disabled,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
  fileChip: {
    margin: theme.spacing(4, 0, 2, 0),
  },
}) )


const acceptImage: Accept = {
  'image/jpeg': ['.jpeg'],
  'image/jpg': ['.jpg'],
  'image/webp': ['.webp'],
  'image/svg': ['.svg'],
  'image/png': ['.png'],
}

export const ImageUpload = ({
  file,
  setFile,
}: {
  file: File | null | undefined
  setFile: (file: File) => void
}): JSX.Element => {

  const onDrop = ([file]: File[]): void => {
    if( file ){
      setFile(file)
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: acceptImage,
  })

  const classes = useImageUploadStyles()

  return (
    <div
      className={classes.dropzone}
      {...getRootProps()}>
      <input
        {...getInputProps()} />
      <Typography
        color='inherit'>
        Drag an image here, or click to select a file
      </Typography>
      { file && (
        <Chip
          className={classes.fileChip}
          color='secondary'
          size='medium'
          icon={<InsertDriveFile />}
          label={
            <span style={{display: 'flex', alignItems: 'center'}}>
              <Typography variant='subtitle2'>
                {file.name}
              </Typography>
              <Typography variant='subtitle1' style={{marginLeft: 6}}>
                {humanReadableFilesize(file.size)}
              </Typography>
            </span>
          } />
      )}
    </div>
  )
}
